/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import LinkDialogButton from "./link-dialog-button";
import { useTheme } from "@mui/material/styles";

const AddLinkButton = (props) => {
    
    const setOpen = props?.setOpen;
    const theme = useTheme();
    
    return (
        <Fragment>
            <div className="simplicity-image-link-link-button">
                <LinkDialogButton
                    setOpen={setOpen}
                    color={theme.palette.primary.main}
                />
            </div>
        </Fragment>
    );
};

export { AddLinkButton };
